function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#5F6C7D",
  d: "M11.8 11.9l-.2-.5c-.1-.2 0-.5 0-.8.6-.5 1-1 1.2-1.6.4-.6.5-1.3.5-1.9 0-1-.3-1.7-1-2.3C11.8 4.3 11 4 10 4c-1 0-1.7.3-2.3.8-.6.6-1 1.3-1 2.3a5.4 5.4 0 001.6 3.5c.2.3.2.5.1.7 0 .3-.1.4-.2.5l-.2.3-1.9.7-1.5 1c-.4.3-.6.7-.6 1v.4c0 1.2 2 1.8 6 1.8s6-.6 6-1.8v-.4c0-.3-.2-.7-.6-1-.5-.5-1-.8-1.5-1l-2-.7-.1-.2z",
  opacity: .2
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#99A3B0",
  d: "M11.8 11.9l-.2-.5c-.1-.2 0-.5 0-.8.6-.5 1-1 1.2-1.6.4-.6.5-1.3.5-1.9 0-1-.3-1.7-1-2.3C11.8 4.3 11 4 10 4c-1 0-1.7.3-2.3.8-.6.6-1 1.3-1 2.3a5.4 5.4 0 001.6 3.5c.2.3.2.5.1.7 0 .3-.1.4-.2.5l-.2.3-1.9.7-1.5 1c-.4.3-.6.7-.6 1v.4c0 1.2 2 1.8 6 1.8s6-.6 6-1.8v-.4c0-.3-.2-.7-.6-1-.5-.5-1-.8-1.5-1l-2-.7-.1-.2zm2.7-.5c.7.3 1.3.7 1.9 1.2.7.6 1 1.4 1 2.2v.4c0 2.5-2.5 3.3-7.4 3.3s-7.5-.8-7.5-3.3v-.4c0-.8.4-1.6 1.2-2.2.5-.5 1.1-.8 1.8-1.2l1.1-.5a6.8 6.8 0 01-1.3-3.8c0-1.4.4-2.6 1.4-3.4 1-.8 2-1.2 3.3-1.2a5 5 0 013.3 1.2c1 .8 1.5 2 1.5 3.4 0 .9-.2 1.7-.6 2.5a7 7 0 01-.8 1.3l1 .5z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/user_icon.b8596906.svg";
export { SvgComponent as ReactComponent };